/**
 * Servicio: Catálogo de Proveedores (simplificado)
 */

import api from './api.js';

class ProveedorService {
  async listar(params = {}) {
    const clean = {};
    Object.keys(params).forEach(k => {
      if (params[k] !== '' && params[k] !== null && params[k] !== undefined) {
        clean[k] = params[k];
      }
    });
    return await api.get('/proveedores', clean);
  }

  async listarActivos() {
    return await api.get('/proveedores/activos');
  }

  async obtenerPorId(id) {
    return await api.get(`/proveedores/${id}`);
  }

  async crear(data) {
    return await api.post('/proveedores', data);
  }

  async actualizar(id, data) {
    return await api.put(`/proveedores/${id}`, data);
  }

  async toggleActivo(id) {
    const response = await fetch(`${api.baseUrl}/proveedores/${id}/toggle`, {
      method: 'PATCH',
      headers: api.getHeaders()
    });
    return await api.handleResponse(response);
  }

  async eliminar(id) {
    return await api.delete(`/proveedores/${id}`);
  }
}

export default new ProveedorService();
